export const ADMIN = "ROLE_ADMIN";
export const USER = "ROLE_USER";
export const STAFF = "ROLE_STAFF";
export const TEACHER = "ROLE_TEACHER";
